import type { UVInsertFaceElementType } from "@shared/models/uv-inserts"
import React from "react"
import { getVisualiserViewModel } from "./Visualiser.vm"
import styles from "./visualiser.module.css"

export * from "./VisualiserTextBox/index"
export * from "./VisualiserGroup/index"
export * from "./VisualiserImageArea/index"

type VisualiserProps = {
  type: UVInsertFaceElementType
  background?: string
  backgroundImageUrl?: string | null
  children?: React.ReactNode
  isGrouped?: boolean
  gap?: string
  subtitle?: string
}

export const Visualiser = ({
  type,
  background,
  backgroundImageUrl,
  children,
  isGrouped,
  gap,
  subtitle,
}: VisualiserProps) => {
  const vm = getVisualiserViewModel({
    type,
    isGrouped,
    background,
    backgroundImageUrl,
    gap,
    subtitle,
  })

  const hasRenderableChildren = React.Children.toArray(children).some((c) => Boolean(c))
  const visualiser = (
    <div className={vm.visualiserClassName} style={vm.visualiserStyle}>
      {hasRenderableChildren ? (
        children
      ) : (
        <span className={styles["visualiser__inert-fill"]} aria-hidden />
      )}
    </div>
  )

  return vm.hasSubtitle ? (
    <div className={vm.subtitleContainerClassName}>
      {visualiser}
      <span>{subtitle}</span>
    </div>
  ) : (
    visualiser
  )
}
